import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const Footer = () => {
    const form = useRef();
    const [message, setMessage] = useState("");
    const sendEmail = (e) => {
        e.preventDefault(); // Prevent default form submission
        const formData = new FormData(form.current);
        const payload = {
            user_email: formData.get("user_email"), // Extract email only
        };

        debugger
        emailjs
            .sendForm(
                "service_wpyyktn",   // Replace with your EmailJS Service ID
                "template_vgukkzi",  // Replace with your EmailJS Template ID
                payload,
                "4pRcUv6De3xvxLrXG"    // Replace with your EmailJS Public Key
            )
            .then(
                (result) => {
                    debugger
                    console.log("Email sent successfully:", result.text);
                    setMessage("Thank you! Your email has been sent.");
                },
                (error) => {
                    console.error("Email send failed:", error.text);
                    setMessage("Oops! Something went wrong.");
                }
            );
        form.current.reset();
    };
    return (
        <footer
            id="qodef-page-footer"
            className="qodef-background--gradient qodef-skin--none"
            role="contentinfo"
        >
            {/* Footer Top Area */}
            <div id="qodef-page-footer-top-area">
                <div id="qodef-page-footer-top-area-inner" className="qodef-content-grid">
                    <div className="qodef-grid qodef-layout--columns qodef-responsive--custom qodef-col-num--3 qodef-col-num--1024--1 qodef-col-num--880--1 qodef-col-num--680--1 qodef-gutter--custom"
                        style={{ "--qode-gutter-custom-1200": "0px", "--qode-gutter-custom-880": "0px" }}>
                        <div className="qodef-grid-inner">
                            <div className="qodef-grid-item">
                                <div
                                    id="startpro_core_single_image-2"
                                    className="widget widget_startpro_core_single_image"
                                    data-area="qodef-footer-top-area-column-1"
                                >
                                    <div className="qodef-shortcode qodef-m  qodef-single-image qodef-layout--default  qodef-border-radius--no qodef-how-border--no qodef--retina   ">
                                        {" "}
                                        <div className="qodef-m-image">
                                            {" "}
                                            <a

                                                href="/"
                                                target="_self"
                                            >
                                                {" "}
                                                <img
                                                    loading="lazy"
                                                    className="qodef-image-original"

                                                    src="/img/pmclogo.png"
                                                    width={183}
                                                    height={42}
                                                    alt=""
                                                />{" "}
                                                <img
                                                    loading="lazy"
                                                    className="qodef-image-dark"

                                                    src="/img/pmclogo.png"
                                                    width={183}
                                                    height={42}
                                                    alt=""
                                                />{" "}
                                            </a>{" "}
                                        </div>{" "}
                                    </div>
                                </div>
                                <div
                                    id="block-14"
                                    className="widget widget_block"
                                    data-area="qodef-footer-top-area-column-1"
                                >
                                    <p className="qodef-copyright m-nav-link">
                                        © 2025{" "}
                                        <a href="/" target="BLANK">
                                            PMC
                                        </a>
                                        , All Rights Reserved
                                    </p>
                                </div>{" "}
                            </div>
                            <div className="qodef-grid-item"></div>
                            <div className="qodef-grid-item">
                                <div
                                    id="startpro_core_separator-6"
                                    className="widget widget_startpro_core_separator"
                                    data-area="qodef-footer-top-area-column-3"
                                >
                                    <div className="qodef-shortcode qodef-m  qodef-separator clear  qodef-show--yes qodef-show-1600--yes qodef-show-1512--yes qodef-show-1368--yes qodef-show-1200--yes qodef-show-1024--yes qodef-show-880--yes qodef-show-680--yes">
                                        {" "}
                                        <div
                                            className="qodef-m-line"
                                            style={{
                                                borderColor: "transparent",
                                                borderBottomWidth: 0,
                                                marginBottom: 14
                                            }}
                                        />
                                    </div>
                                </div>
                                <div
                                    id="startpro_core_icon_list_item-3"
                                    className="widget widget_startpro_core_icon_list_item"
                                    data-area="qodef-footer-top-area-column-3"
                                >
                                    <div className="qodef-icon-list-item qodef-icon--icon-pack  ">
                                        {" "}
                                        <h6 className="qodef-widget-title">Contact</h6>
                                        <p className="qodef-e-title" style={{ color: "#ffffff" }}>
                                            {" "}
                                            <a href="mailto:info@pmcoman.com" target="_self" className=" location-hover hover-icon-bounce">
                                                {" "}
                                                <span className="qodef-e-title-inner">
                                                    {" "}
                                                    <span
                                                        className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--normal cms-eicon"
                                                        data-hover-color="#e5ff5e"
                                                    >
                                                        {" "}
                                                        <span
                                                            className="qodef-icon-font-awesome fa fa-envelope qodef-icon qodef-e"
                                                            style={{ color: "#349383" }}
                                                        />{" "}
                                                    </span>{" "}
                                                    <span className="qodef-e-title-text m-nav-link">info@pmcoman.com</span>{" "}
                                                </span>{" "}
                                            </a>{" "}
                                        </p>
                                    </div>
                                </div>
                                <div
                                    id="startpro_core_separator-8"
                                    className="widget widget_startpro_core_separator"
                                    data-area="qodef-footer-top-area-column-3"
                                >
                                    <div className="qodef-shortcode qodef-m  qodef-separator clear  qodef-show--yes qodef-show-1600--yes qodef-show-1512--yes qodef-show-1368--yes qodef-show-1200--yes qodef-show-1024--yes qodef-show-880--yes qodef-show-680--yes">
                                        {" "}
                                        <div
                                            className="qodef-m-line"
                                            style={{
                                                borderColor: "transparent",
                                                borderBottomWidth: 0,
                                                marginBottom: 15
                                            }}
                                        />
                                    </div>
                                </div>
                                <div
                                    id="startpro_core_icon_list_item-5"
                                    className="widget widget_startpro_core_icon_list_item"
                                    data-area="qodef-footer-top-area-column-3"
                                >
                                    <div className="qodef-icon-list-item qodef-icon--icon-pack  ">
                                        {" "}
                                        <p className="qodef-e-title" style={{ color: "#ffffff" }}>
                                            {" "}
                                            <a

                                                href="https://www.google.com/maps/place/PMC+Head+Office/@23.601896,58.448351,1992m/data=!3m1!1e3!4m6!3m5!1s0x3e91ff39823b555b:0x8ecbe6acff6cbd21!8m2!3d23.6012524!4d58.4488394!16s%2Fg%2F11cscc9f93?hl=en&entry=ttu&g_ep=EgoyMDI1MDMwOC4wIKXMDSoASAFQAw%3D%3D"
                                                target="_blank"
                                                className="location-hover hover-icon-bounce"
                                            >
                                                {" "}
                                                <span className="qodef-e-title-inner">
                                                    {" "}
                                                    <span
                                                        className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--normal cms-eicon"
                                                        data-hover-color="#e5ff5e"
                                                        style={{ margin: "0px 11px 0px 2px" }}
                                                    >
                                                        {" "}
                                                        <span
                                                            className="qodef-icon-font-awesome fa fa-location-pin qodef-icon qodef-e"
                                                            style={{ color: "#349383" }}
                                                        />{" "}
                                                    </span>{" "}
                                                    <span className="qodef-e-title-text m-nav-link">
                                                        PMC Head Office
                                                        JC2X+GG4, Muscat, Oman
                                                    </span>{" "}
                                                </span>{" "}
                                            </a>{" "}
                                        </p>
                                    </div>
                                </div>{" "}
                                <div
                                    id="startpro_core_icon_list_item-5"
                                    className="widget widget_startpro_core_icon_list_item"
                                    data-area="qodef-footer-top-area-column-3"
                                >
                                    <div className="qodef-icon-list-item qodef-icon--icon-pack  ">
                                        {" "}
                                        <p className="qodef-e-title" style={{ color: "#ffffff" }}>
                                            {" "}
                                            <a

                                                href="tel:+968 2285 0704"
                                                target="_blank"
                                                className="location-hover hover-icon-bounce"
                                            >
                                                {" "}
                                                <span className="qodef-e-title-inner">
                                                    {" "}
                                                    <span
                                                        className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--normal cms-eicon"
                                                        data-hover-color="#e5ff5e"
                                                        style={{ margin: "0px 11px 0px 2px" }}
                                                    >
                                                        {" "}
                                                        <span
                                                            className="qodef-icon-font-awesome fa fa-mobile-phone qodef-icon qodef-e"
                                                            style={{ color: "#349383" }}
                                                        />{" "}
                                                    </span>{" "}
                                                    <span className="qodef-e-title-text m-nav-link">

                                                        +968 2285 0704
                                                    </span>{" "}
                                                </span>{" "}
                                            </a>{" "}
                                        </p>
                                    </div>
                                </div>
                                <div
                                    id="startpro_core_icon_list_item-5"
                                    className="widget widget_startpro_core_icon_list_item"
                                    data-area="qodef-footer-top-area-column-3"
                                >
                                    <div className="qodef-icon-list-item qodef-icon--icon-pack  ">
                                        {" "}
                                        <p className="qodef-e-title" style={{ color: "#ffffff" }}>
                                            {" "}
                                            <a

                                                href="tel:+968 9722 0899"
                                                target="_blank"
                                                className="location-hover hover-icon-bounce"
                                            >
                                                {" "}
                                                <span className="qodef-e-title-inner">
                                                    {" "}
                                                    <span
                                                        className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--normal cms-eicon"
                                                        data-hover-color="#e5ff5e"
                                                        style={{ margin: "0px 11px 0px 2px" }}
                                                    >
                                                        {" "}
                                                        <span
                                                            className="qodef-icon-font-awesome fa fa-mobile-phone qodef-icon qodef-e"
                                                            style={{ color: "#349383" }}
                                                        />{" "}
                                                    </span>{" "}
                                                    <span className="qodef-e-title-text m-nav-link">
                                                        +968 9722 0899
                                                    </span>{" "}
                                                </span>{" "}
                                            </a>{" "}
                                        </p>
                                    </div>
                                </div>
                                          <div
                                    id="startpro_core_icon_list_item-5"
                                    className="widget widget_startpro_core_icon_list_item"
                                    data-area="qodef-footer-top-area-column-3"
                                >
                                    <div className="qodef-icon-list-item qodef-icon--icon-pack  ">
                                        {" "}
                                        <p className="qodef-e-title" style={{ color: "#ffffff" }}>
                                            {" "}
                                            <a

                                                href="tel:+968 24210072"
                                                target="_blank"
                                                className="location-hover hover-icon-bounce"
                                            >
                                                {" "}
                                                <span className="qodef-e-title-inner">
                                                    {" "}
                                                    <span
                                                        className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--normal cms-eicon"
                                                        data-hover-color="#e5ff5e"
                                                        style={{ margin: "0px 11px 0px 2px" }}
                                                    >
                                                        {" "}
                                                        <span
                                                            className="qodef-icon-font-awesome fa fa-mobile-phone qodef-icon qodef-e"
                                                            style={{ color: "#349383" }}
                                                        />{" "}
                                                    </span>{" "}
                                                    <span className="qodef-e-title-text m-nav-link">
                                                        +968 24210072
                                                    </span>{" "}
                                                </span>{" "}
                                            </a>{" "}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer Bottom Area */}
            <div id="qodef-page-footer-bottom-area">
                <div
                    id="qodef-page-footer-bottom-area-inner"
                    className="qodef-content-grid"
                >
                    <div className="qodef-grid qodef-layout--columns qodef-responsive--custom qodef-col-num--4 qodef-gutter--custom qodef-columns-distribution--60-20-20-20"
                        style={{ "--qode-gutter-custom-880": "45px" }}>
                        <div className="qodef-grid-inner">
                            {/* Newsletter Subscription */}
                            <div className="qodef-grid-item">
                                <div
                                    id="startpro_core_contact_form_7-3"
                                    // className="widget widget_startpro_core_contact_form_7"
                                    data-area="qodef-footer-top-area-column-1"
                                >
                                    {/* <h6 className="qodef-widget-title">
                                        Subscribe to our newsletter
                                    </h6> */}
                                    <div className="qodef-contact-form-7 ">
                                        <div className="wpcf7 js">
                                            <form
                                                ref={form}
                                                className="wpcf7-form init"
                                                aria-label="Contact form"
                                                noValidate="novalidate"
                                                data-status="init"
                                                onSubmit={sendEmail}
                                            >

                                                <div className="qodef-footer-newsletter">
                                                    <span className="wpcf7-form-control-wrap" data-name="your-email">
                                                        {/* <input


                                                            className="wpcf7-form-control wpcf7-email wpcf7-validates-as-required wpcf7-text wpcf7-validates-as-email"
                                                            autoComplete="email"

                                                            placeholder="E-mail"
                                                            defaultValue=""
                                                            type="email"
                                                            name="user_email"
                                                            
                                                            required
                                                        /> */}
                                                    </span>
                                                    {/* {message && <span className="wpcf7-not-valid-tip" aria-hidden="true">{message}</span>} */}
                                                    {/* <button
                                                        className="wpcf7-form-control wpcf7-submit qodef-button qodef-size--normal qodef-layout--filled qodef-m"
                                                        type="submit"
                                                    >
                                                        <span className="qodef-m-text">Send message</span>
                                                    </button> */}
                                                </div>

                                                {/* <div className="wpcf7-response-output" aria-hidden="true" /> */}
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <div className="widget widget_block">
                                    <div className="wp-block-group is-nowrap is-layout-flex wp-container-core-group-is-layout-1 wp-block-group-is-layout-flex">
                                        <div className="widget widget_startpro_core_svg_icon" style={{ paddingRight: "10px" }}>
                                            <div className="qodef-svg-icon-widget">
                                                <a href="https://www.instagram.com/pmc_oman/" target="_blank">
                                                    <div className="qodef-m-holder" style={{ alignItems: "center" }}>
                                                        <div className="qodef-m-icon" style={{
                                                            '--stroke-color': '#0c4651',               // Custom property for stroke color
                                                            '--stroke-hover-color': '#0c4651',          // Custom property for stroke hover color
                                                            '--fill-color': '#0c4651',                     // Custom property for fill color
                                                            '--fill-hover-color': '#ffffff',               // Custom property for fill hover color
                                                            '--background-color': '#0c4651',               // Custom property for background color
                                                            '--background-hover-color': '#349383',       // Custom property for background hover color
                                                            width: '30px',                                 // Width of the element
                                                            height: '30px',                                // Height of the element
                                                            borderRadius: '50%',                           // Makes the element circular
                                                            '--border-color': '#0c4651',                   // Custom property for border color
                                                            '--border-hover-color': '#ffffff',             // Custom property for border hover color
                                                            backgroundColor: '#34938380',   // Using the custom property for background
                                                            // border: '2px solid var(--border-color)',       // Using the custom property for border
                                                            display: 'flex',                               // Flexbox for centering content
                                                            alignItems: 'center',                          // Center content vertically
                                                            justifyContent: 'center',                       // Center content horizontally
                                                            cursor: 'pointer',                             // Change cursor to pointer
                                                            transition: 'background-color 0.3s, border 0.3s', // Smooth transition for hover effects
                                                        }}>
                                                            {/* <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="10.827"
                                                                height="10.824"
                                                                viewBox="0 0 10.827 10.824"
                                                            >
                                                                <path
                                                                    d="M5.339,34.462a2.775,2.775,0,1,0,2.775,2.775A2.771,2.771,0,0,0,5.339,34.462Zm0,4.579a1.8,1.8,0,1,1,1.8-1.8,1.808,1.808,0,0,1-1.8,1.8Zm3.536-4.693a.647.647,0,1,1-.647-.647A.646.646,0,0,1,8.875,34.348Zm1.838.657a3.2,3.2,0,0,0-.874-2.268,3.224,3.224,0,0,0-2.268-.874c-.894-.051-3.572-.051-4.466,0a3.22,3.22,0,0,0-2.268.872A3.214,3.214,0,0,0-.037,35c-.051.894-.051,3.572,0,4.466a3.2,3.2,0,0,0,.874,2.268,3.228,3.228,0,0,0,2.268.874c.894.051,3.572.051,4.466,0a3.2,3.2,0,0,0,2.268-.874,3.224,3.224,0,0,0,.874-2.268C10.764,38.575,10.764,35.9,10.713,35.005ZM9.559,40.428A1.827,1.827,0,0,1,8.53,41.457a11.929,11.929,0,0,1-3.191.217,12.022,12.022,0,0,1-3.191-.217A1.827,1.827,0,0,1,1.12,40.428,11.929,11.929,0,0,1,.9,37.237a12.022,12.022,0,0,1,.217-3.191,1.827,1.827,0,0,1,1.029-1.029A11.929,11.929,0,0,1,5.339,32.8a12.022,12.022,0,0,1,3.191.217,1.827,1.827,0,0,1,1.029,1.029,11.929,11.929,0,0,1,.217,3.191A11.922,11.922,0,0,1,9.559,40.428Z"
                                                                    transform="translate(0.075 -31.825)"
                                                                />
                                                            </svg>{" "} */}
                                                            <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="10.827"
                                                                height="10.824" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">

                                                                <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                                                                    <path d="M1685 5109 c-137 -4 -295 -12 -350 -19 -404 -48 -691 -181 -926 -427 -257 -270 -366 -579 -399 -1123 -13 -217 -13 -1708 0 -1936 32 -564 142 -876 403 -1151 233 -245 536 -378 977 -429 290 -34 2063 -29 2375 6 407 46 681 165 918 398 221 218 353 507 402 882 46 346 46 2154 0 2502 -85 649 -419 1057 -994 1219 -173 48 -345 68 -688 79 -345 11 -1336 11 -1718 -1z m1840 -460 c706 -47 1014 -289 1099 -862 28 -183 39 -668 33 -1447 -5 -721 -10 -838 -43 -1045 -71 -447 -336 -714 -784 -789 -185 -31 -322 -37 -955 -42 -959 -9 -1457 10 -1681 62 -361 83 -590 312 -685 683 -52 203 -54 252 -54 1331 0 907 2 1019 18 1148 56 449 199 697 482 837 101 50 264 96 415 116 186 24 1822 31 2155 8z" />
                                                                    <path d="M3827 4216 c-214 -77 -276 -345 -116 -505 64 -63 120 -86 214 -86 67 0 89 4 137 28 101 50 158 137 166 253 7 103 -16 163 -87 235 -38 38 -72 61 -105 72 -59 20 -156 21 -209 3z" />
                                                                    <path d="M2330 3854 c-250 -45 -485 -165 -670 -341 -191 -182 -312 -390 -377 -650 -25 -97 -27 -126 -28 -293 0 -252 31 -396 131 -594 196 -390 567 -655 1003 -717 128 -18 352 -6 478 25 385 96 692 341 871 696 90 178 132 366 132 586 0 348 -124 653 -367 905 -198 204 -445 336 -717 384 -109 19 -350 18 -456 -1z m404 -459 c165 -34 302 -109 427 -234 158 -158 237 -336 247 -557 5 -141 -6 -220 -49 -340 -99 -273 -344 -480 -638 -540 -64 -12 -113 -15 -200 -11 -141 7 -206 24 -336 87 -216 104 -378 298 -446 532 -30 105 -37 279 -15 389 69 338 326 600 661 674 82 18 260 18 349 0z" />
                                                                </g>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="widget widget_startpro_core_svg_icon" style={{ paddingRight: "10px" }}>
                                            <div className="qodef-svg-icon-widget">
                                                <a href="https://www.linkedin.com/company/pmc-oman/" target="_blank">
                                                    <div className="qodef-m-holder" style={{ alignItems: "center" }}>
                                                        <div className="qodef-m-icon" style={{
                                                            '--stroke-color': '#0c4651',               // Custom property for stroke color
                                                            '--stroke-hover-color': '#0c4651',          // Custom property for stroke hover color
                                                            '--fill-color': '#0c4651f',                     // Custom property for fill color
                                                            '--fill-hover-color': '#ffffff',               // Custom property for fill hover color
                                                            '--background-color': '#0c4651',               // Custom property for background color
                                                            '--background-hover-color': '#ffffff00',       // Custom property for background hover color
                                                            width: '30px',                                 // Width of the element
                                                            height: '30px',                                // Height of the element
                                                            borderRadius: '50%',                           // Makes the element circular
                                                            '--border-color': '#0c4651',                   // Custom property for border color
                                                            '--border-hover-color': '#ffffff',             // Custom property for border hover color
                                                            backgroundColor: '#34938380',    // Using the custom property for background
                                                            // border: '2px solid #fff',       // Using the custom property for border
                                                            display: 'flex',                               // Flexbox for centering content
                                                            alignItems: 'center',                          // Center content vertically
                                                            justifyContent: 'center',                       // Center content horizontally
                                                            cursor: 'pointer',                             // Change cursor to pointer
                                                            transition: 'background-color 0.3s, border 0.3s', // Smooth transition for hover effects
                                                        }}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="12.623" height="15.366" viewBox="0 0 448 512"><path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z" /></svg>

                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="widget widget_startpro_core_svg_icon" style={{ paddingRight: "10px" }}>
                                            <div className="qodef-svg-icon-widget">
                                                <a href="https://x.com/pmc__oman" target="_blank">
                                                    <div className="qodef-m-holder" style={{ alignItems: "center" }}>
                                                        <div className="qodef-m-icon" style={{
                                                            '--stroke-color': '#0c4651',               // Custom property for stroke color
                                                            '--stroke-hover-color': '#0c4651',          // Custom property for stroke hover color
                                                            '--fill-color': '#0c4651',                     // Custom property for fill color
                                                            '--fill-hover-color': '#ffffff',               // Custom property for fill hover color
                                                            '--background-color': '#0c4651',               // Custom property for background color
                                                            '--background-hover-color': '#ffffff00',       // Custom property for background hover color
                                                            width: '30px',                                 // Width of the element
                                                            height: '30px',                                // Height of the element
                                                            borderRadius: '50%',                           // Makes the element circular
                                                            '--border-color': '#0c4651',                   // Custom property for border color
                                                            '--border-hover-color': '#ffffff',             // Custom property for border hover color
                                                            backgroundColor: '#34938380',    // Using the custom property for background
                                                            // border: '2px solid var(--border-color)',       // Using the custom property for border
                                                            display: 'flex',                               // Flexbox for centering content
                                                            alignItems: 'center',                          // Center content vertically
                                                            justifyContent: 'center',                       // Center content horizontally
                                                            cursor: 'pointer',                             // Change cursor to pointer
                                                            transition: 'background-color 0.3s, border 0.3s', // Smooth transition for hover effects
                                                        }}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="20.623" height="17.366" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">

                                                                <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                                                                    <path d="M2825 4580 c-361 -74 -599 -286 -705 -629 -39 -125 -50 -239 -50 -538 l0 -283 -272 0 c-302 0 -315 -3 -335 -60 -17 -49 -17 -671 0 -720 19 -54 44 -59 345 -59 l262 -1 0 -859 0 -860 24 -28 24 -28 359 -3 c386 -3 422 0 441 43 9 19 12 253 12 885 l0 859 335 3 c305 3 336 5 352 21 17 16 18 46 18 392 l0 374 -23 23 c-22 23 -24 23 -353 26 l-331 3 4 267 c3 287 6 301 61 353 41 39 66 43 345 48 l274 6 24 28 24 28 0 340 0 340 -25 24 -24 25 -348 -1 c-297 -1 -361 -3 -438 -19z" transform="translate(-22.89)" />
                                                                </g>
                                                            </svg>
                                                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="6.623" height="12.366" viewBox="0 0 6.623 12.366"><path d="M29.079,6.956l.343-2.238H27.275V3.266a1.119,1.119,0,0,1,1.262-1.209h.976V.151A11.905,11.905,0,0,0,27.78,0a2.732,2.732,0,0,0-2.924,3.012V4.718H22.89V6.956h1.966v5.41h2.419V6.956Z" transform="translate(-22.89)"></path></svg> */}
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="widget widget_startpro_core_svg_icon">
                                            <div className="qodef-svg-icon-widget">
                                                <a href="https://www.facebook.com/pmcoman/" target="_blank">
                                                    <div className="qodef-m-holder" style={{ alignItems: "center" }}>
                                                        <div className="qodef-m-icon" style={{
                                                            '--stroke-color': '#0c4651',               // Custom property for stroke color
                                                            '--stroke-hover-color': '#0c4651',          // Custom property for stroke hover color
                                                            '--fill-color': '#0c4651',                     // Custom property for fill color
                                                            '--fill-hover-color': '#ffffff',               // Custom property for fill hover color
                                                            '--background-color': '#0c4651',               // Custom property for background color
                                                            '--background-hover-color': '#ffffff00',       // Custom property for background hover color
                                                            width: '30px',                                 // Width of the element
                                                            height: '30px',                                // Height of the element
                                                            borderRadius: '50%',                           // Makes the element circular
                                                            '--border-color': '#0c4651',                   // Custom property for border color
                                                            '--border-hover-color': '#ffffff',             // Custom property for border hover color
                                                            backgroundColor: '#34938380',    // Using the custom property for background
                                                            // border: '2px solid var(--border-color)',       // Using the custom property for border
                                                            display: 'flex',                               // Flexbox for centering content
                                                            alignItems: 'center',                          // Center content vertically
                                                            justifyContent: 'center',                       // Center content horizontally
                                                            cursor: 'pointer',                             // Change cursor to pointer
                                                            transition: 'background-color 0.3s, border 0.3s', // Smooth transition for hover effects
                                                        }}>

                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14.623" height="12.366" viewBox="0 0 512 512" ><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" /></svg>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="qodef-grid-item">

                            </div>
                            <div className="qodef-grid-item">
                                <div
                                    id="nav_menu-2"
                                    className="widget widget_nav_menu"
                                    data-area="qodef-footer-bottom-area-column-2"
                                >
                                    <h6 className="qodef-widget-title">Quick Link</h6>
                                    <div className="menu-footer-bottom-column-2-container">
                                        <ul id="menu-footer-bottom-column-2" className="menu">
                                            <li
                                                id="menu-item-2872"
                                                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-2872"
                                            >
                                                <a href="/" className="m-nav-link">
                                                    Home
                                                </a>
                                            </li>
                                            <li
                                                id="menu-item-2873"
                                                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-2873"
                                            >
                                                <a href="/about_us" className="m-nav-link">
                                                    About Us
                                                </a>
                                            </li>
                                            <li
                                                id="menu-item-2874"
                                                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-2874"
                                            >
                                                <a href="/projects" className="m-nav-link">
                                                    Projects
                                                </a>
                                            </li>
                                            {/* <li
                                                id="menu-item-2875"
                                                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-2875"
                                            >
                                                <a href="/">
                                                    Services
                                                </a>
                                            </li> */}
                                        </ul>
                                    </div>
                                </div>{" "}
                            </div>
                            <div className="qodef-grid-item">
                                <div
                                    id="nav_menu-3"
                                    className="widget widget_nav_menu"
                                    data-area="qodef-footer-bottom-area-column-3"
                                >
                                    <h6 className="qodef-widget-title">Services</h6>
                                    <div className="menu-footer-bottom-column-3-container">
                                        <ul id="menu-footer-bottom-column-3" className="menu">
                                            <li
                                                id="menu-item-2876"
                                                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-2876"
                                            >
                                                <a href="/service/projects_management" className="m-nav-link">

                                                    Project Management
                                                </a>
                                            </li>
                                            <li
                                                id="menu-item-2877"
                                                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-2877"
                                            >
                                                <a href="/service/management_consultancy" className="m-nav-link">
                                                    Management Consultancy
                                                </a>
                                            </li>
                                            <li
                                                id="menu-item-2878"
                                                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-2878"
                                            >
                                                <a href="/service/arbitrary_&_legal" className="m-nav-link">

                                                    Arbitrary and Legal Services
                                                </a>
                                            </li>
                                            {/* <li
                                                id="menu-item-2879"
                                                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-2879"
                                            >
                                                <a href="">
                                                    Digital payments
                                                </a>
                                            </li> */}
                                        </ul>
                                    </div>
                                </div>{" "}
                            </div>





                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
